export var SIDES;
(function (SIDES) {
    SIDES[SIDES["NONE"] = 0] = "NONE";
    SIDES[SIDES["LEFT"] = 1] = "LEFT";
    SIDES[SIDES["RIGHT"] = 2] = "RIGHT";
    SIDES[SIDES["TOP"] = 3] = "TOP";
    SIDES[SIDES["BOTTOM"] = 4] = "BOTTOM";
})(SIDES || (SIDES = {}));
export class Collision {
    constructor(obj1, obj2, callback) {
        this.obj1 = obj1;
        this.obj2 = obj2;
        this.callback = callback;
    }
}
//# sourceMappingURL=Collisions.js.map